
<v-container
    v-if="site"
    class="abstract-container lm-border mt-3 pa-3 " style="border-width: 1px; width: calc(100% - -9px);"
    :style="'height:' + height + 'px'"
>

    <div class="w-100">
        <div class="step-title w-100" style="position:relative;">
            <div class=" primary--text" style="padding-top: 3px;">
                <span>ZÜS-Prüfung für Anlage {{site.fabricNo }}</span>
            </div>
            <div class="v-flex" style="position: absolute; right: -6px">
                <c-toolbar-button
                    :ripple = "false"
                    v-if="incidentId"
                    icon="mdi-arrow-right-thin-circle-outline"
                    color="primary"
                    size="22"
                    tooltip="Zur ZÜS Prüfung wechseln"
                    @click="onGoto"
                />
                <c-toolbar-button
                    :ripple = "false"
                    icon="mdi-refresh"
                    color="primary"
                    size="22"
                    tooltip="ZÜS Prüfungsliste aktualisieren"
                    @click="onRefreshAssessments"
                />
            </div>
        </div>

        <div class="abstract-group " >
            <v-row class="no-frame abstract-info">
                <v-col class="no-frame col-12 pr-1">
                    <v-select
                        label="Prüfung"
                        class="mt-0"
                        :items = "selections"
                        item-value     = "id"
                        item-text      = "name"
                        :return-object = true
                        :rules = "[ requiredRule ]"
                        v-model="selection"
                        @change = "onSelected"
                    />

                </v-col>
            </v-row>

            <v-row class="no-frame abstract-info mt-5">
                <v-col class="no-frame col-6 pr-1">
                    <f-read-only-field filled dense label="ZÜS" :value="company" />
                </v-col>
                <v-col class="no-frame col-6 pl-1" >
                    <f-read-only-field filled dense label="Status" :value="status" />
                </v-col>
            </v-row>

            <v-row class="no-frame abstract-info mt-2">
                <v-col class="no-frame col-6 pr-1">
                    <f-read-only-field filled dense label="Prüfungsergebnis" :value="result" />
                </v-col>
                <v-col class="no-frame col-6 pl-1" >
                    <f-read-only-field filled dense label="Datum der Prüfung" :value="assessmentDate" />
                </v-col>
            </v-row>

            <v-row class="no-frame abstract-info mt-3">
                <v-col class="no-frame col-6 pr-1">
                    <f-read-only-field filled dense label="Nächste Prüfung" :value= "nextAssessment" />
                </v-col>
                <v-col class="no-frame col-6 pl-1" >
                    <f-read-only-field
                        label="Nachprüfung bis"
                        :value="dateRemedyOfDefects"
                        filled
                        dense
                    />
                </v-col>
            </v-row>
        </div>
    </div>
</v-container>
